import React, { useCallback, useMemo, useState } from "react";
import { SCORING_BASE_ROOT_URL } from "src/config/constants";
import { COLOR_ARRAY } from "src/config/styleConfig";
import useAuthorizationClient from "src/hooks/useAuthorizationClient";

const TransactionMonitoringContext = React.createContext({});

const TransactionMonitoringProvider = ({ children }) => {
  const [transactionData, setTransactionData] = useState({});
  const client = useAuthorizationClient(`${SCORING_BASE_ROOT_URL}/pool-analysis`);

  const _fetchTransactionData = async (pool, params, active) => {
    try {
      params["lending"] = pool;
      const data = await client.get("/transactions/event-data", { params: params });
      let _data = data.data;
      _data = _data.map((element) => {
        let color = "";
        if (element["event_type"] === "DEPOSIT") color = COLOR_ARRAY[0];
        else if (element["event_type"] === "BORROW") color = COLOR_ARRAY[1];
        else if (element["event_type"] === "WITHDRAW") color = COLOR_ARRAY[2];
        else if (element["event_type"] === "REPAY") color = COLOR_ARRAY[3];
        element["color"] = color;
        return element;
      });

      const _tempData = transactionData;
      _tempData[pool] = {
        data: _data,
        metadata: params,
        active,
      };
      setTransactionData({ ..._tempData });
    } catch (error) {
      console.error(error);
    }
  };

  const fetchTransactionData = useCallback(
    async (pool, params, config) => {
      if (client) {
        if (!params?.from || !params?.to) {
          var currentTime = Math.floor(Date.now() / 1000);
          params.from = currentTime - 86400;
          params.to = currentTime;
        }
        if (transactionData[pool]) {
          const metadata = transactionData[pool]["metadata"];
          const _check = metadata == params;
          if (_check) return;
          else await _fetchTransactionData(pool, params, config?.active);
        } else await _fetchTransactionData(pool, params, config?.active);
      }
    },
    [client]
  );

  const contextData = useMemo(() => {
    return {
      transactionData,
      fetchTransactionData,
    };
  }, [transactionData, fetchTransactionData]);

  return <TransactionMonitoringContext.Provider value={contextData}>{children}</TransactionMonitoringContext.Provider>;
};

export default TransactionMonitoringProvider;

export const useTransactionMonitoringContext = () => React.useContext(TransactionMonitoringContext);

export const useTransactionMonitoringSelector = (selectorFn) => {
  const result = useTransactionMonitoringContext();

  return useMemo(() => selectorFn(result), [result, selectorFn]);
};
